export class ValidacionFecha
{
    valida:boolean = false;
    motivo:string = "";

    constructor(v:boolean,m:string)
    {
        this.valida=v;
        this.motivo=m;
    }

    //Retorna una validacion valida
    public static darValido():ValidacionFecha
    {
        return new ValidacionFecha(true,"OK");
    }



  //retrna true si la fecha seleccionada está disponible para agendar
  //false en caso contrario
  public static comprobarFechaDisponible(fecha:Date,fechasNoDisponibles:string[],aperturaSabado:boolean):ValidacionFecha
  {
    //console.log("FECHAS NO DISPONIBLES: "+this.fechasNoDisponibles)
    let f = ValidacionFecha.formatearFecha(fecha!);
    //Comprobamos si la fecha es menor o igual a hoy
    if(fecha <= new Date())
        return  new ValidacionFecha(false,"La fecha debe mayor a la fecha actual");
    //Comprobamos si es domingo
    if(fecha.getDay()==0)
        return  new ValidacionFecha(false,"Los talleres no abren los domingos");
    //COmprobamos que no este cerrado el taller ese dia
    if(fechasNoDisponibles.includes(f))
      return  new ValidacionFecha(false,"El taller esta cerrado el día seleccionado.");
    //Comporbamos si es sabado, en ese caso, comprobamos si el taller abre los sábados
    if(fecha.getDay()==6)
    {
      let validezSabado : ValidacionFecha = new ValidacionFecha(false,"El taller no abre los sábados.");
      return (!aperturaSabado ? validezSabado : ValidacionFecha.darValido());
      //return (aperturaSabado == "CERRADO" || false ?  validezSabado : ValidacionFecha.darValido());
    }

    return ValidacionFecha.darValido();
  }
  public static formatearFecha(fecha:Date):string
  {
    if (!fecha)
      fecha = new Date(); // set fecha to current date if it's null

    let dia = fecha.getDate().toString();
    let mes = (fecha.getMonth() + 1).toString();
    let year = fecha.getFullYear().toString();

    return dia+"-"+mes+"-"+year;
  }
}
